// mutation_types
export const SET_LISTING_STATUS = 'SET_LISTING_STATUS';
export const SET_LISTING = 'SET_LISTING';
export const SET_CURRENT_LISTING_STATUS = 'SET_CURRENT_LISTING_STATUS';
export const SET_CURRENT_LISTING_NAME = 'SET_CURRENT_LISTING_NAME';
export const SET_FETCH_LISTING_STATUS = 'SET_FETCH_LISTING_STATUS';
export const SET_TOTAL_PAGE = 'SET_TOTAL_PAGE';
export const SET_PAGE_NUM = 'SET_PAGE_NUM';
export const SET_SHOW_SOLD_LISTING_PRICE = 'SET_SHOW_SOLD_LISTING_PRICE';
export const SET_SHOW_LISTING_PRICE = 'SET_SHOW_LISTING_PRICE';
export const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS';
export const SET_HAS_LOCATION = 'SET_HAS_LOCATION';
export const SET_SOLD_LISTING_INFO = 'SET_SOLD_LISTING_INFO';
// action_types
export const GET_LISTING_STATUS = 'GET_LISTING_STATUS';
export const GET_LISTING = 'GET_LISTING';
export const ADD_SOLD_PICTURE = 'ADD_SOLD_PICTURE';
export const SET_HAS_FETCH_LISITNG_STATUS = 'SET_HAS_FETCH_LISITNG_STATUS';
export const SET_SHOW_THIS_MODULE  = 'SET_SHOW_THIS_MODULE';
